export default "/_next/static/chunks/fonts/Raleway Medium-0de5925709848b7e64c5355ab31d6f95.ttf";